import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import { createForm } from 'rc-form'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

const ForgetPasswordDialog = props => {
    const { t } = useTranslation();
    const countdownTime = 60
    const [timer, setTimer] = useState(false);
    const [second, setSecond] = useState(countdownTime);

    const onSendEmail = type => {
        props.form.validateFields((error, value) => {
            if (!error) {
                setTimer(true)
                props.onSubmit(value.email)
            }
        })
    }
    
    useEffect(() => {
        let interval
        if (timer) {
            interval = setInterval(() => {
                setSecond(preSecond => {
                    if (preSecond <= 1) {
                        setTimer(false)
                        clearInterval(interval)
                        return countdownTime
                    } else {
                        return preSecond - 1
                    }
                })
            }, 1000)
        }
        return () => clearInterval(interval)
    }, [timer])

    const { form, open, onClose, onActionChange } = props
    const { getFieldProps, getFieldError } = form
    const emailErr = getFieldError('email')

    return (
        <Dialog className="dialog" open={open} onClose={onClose}>
            <DialogTitle disableTypography className="dialog-title" style={{paddingTop: '32px'}}>
                <Typography variant="h4">忘記密碼了嗎？</Typography>
                <CloseIcon className="dialog-close" onClick={onClose} />
            </DialogTitle>
            <DialogContent style={{ padding: '0 32px 12px' }}>
                <span className="text-grey"><Typography color="inherit">在下面輸入您的電子郵件地址，我們將發送重置密碼的連結給您。</Typography></span>
                <div className="d-flex align-items-center" style={{ margin: '28px 0 12px 0' }}>
                    <div style={{ height: '1px', width: '100%', backgroundColor: 'rgba(74, 79, 85, 0.1)' }}></div>
                </div>
                <TextField
                    name="email"
                    id="email"
                    size="small"
                    variant="outlined"
                    placeholder="電子郵件"
                    inputProps={{...getFieldProps('email', {
                        initialValue: '',
                        rules: [{
                            type: 'email',
                            required: true
                        }]
                    })}}
                    margin="normal"
                    style={{ width: '100%' }}
                    error={emailErr && emailErr !== null}
                    helperText={emailErr || ''}
                    FormHelperTextProps={{
                        error: emailErr && emailErr !== null
                    }}
                />
                {timer
                    ?
                        <Grid className="resend-func" style={{marginTop: '20px'}}>
                            <Grid item className="text-center">
                                <Button color="secondary" variant="contained" disabled>
                                    重置連結已發送
                                </Button>
                            </Grid>
                            <Grid item className="text-center">
                                <Typography className="text-grey">重新發送({second})</Typography>
                            </Grid>
                        </Grid>
                    :
                        <Grid className="resend-func text-center">
                            <Button color="primary" variant="contained" onClick={onSendEmail}>
                                發送重置連結 
                            </Button>
                        </Grid>
                }
            </DialogContent>
            <DialogActions className="dialog-func">
                <Grid container justify="space-between" alignItems="center"  style={{marginTop: '20px'}}>
                    <Typography className="typography">
                        <span onClick={() => onActionChange('login')}>返回登入</span>
                    </Typography>
                </Grid>
            </DialogActions>
        </Dialog>
  )
}

export default createForm()(ForgetPasswordDialog)